import {
  Component,
  EventEmitter,
  Input,
  Output,
  OnInit,
  ChangeDetectionStrategy,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { uniqueId } from 'lodash';

import { RadioComponent } from '../radio/radio.component';

@Component({
  selector: 'aprova-radio-group',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, RadioComponent],
  templateUrl: './radio-group.component.html',
  styleUrls: ['./radio-group.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RadioGroupComponent implements OnInit {
  @Input()
  public id: string = uniqueId('aprova-radio-group-');

  @Input()
  public name: string = '';

  @Input()
  public label: string = '';

  @Input()
  public labelClass: string = 'block text-sm font-semibold leading-6 text-gray-500';

  @Input()
  public radioOptions: { label: string; value: string; disabled?: boolean }[] = [];

  @Input()
  public control = new FormControl<boolean | string | number>(false);

  @Input()
  public optionalTag: boolean = false;

  @Input()
  public vertical: boolean = false;

  @Input()
  public disabled: boolean = false;

  @Output()
  onChange = new EventEmitter<string | number>();

  ngOnInit(): void {
    if (!this.name) {
      this.name = this.id;
    }
  }

  public onValueChange(value: string | number): void {
    this.control.setValue(value);
    this.onChange.emit(value);
  }
}
